import React, { useId } from "react";

type HardDriveOffIconProps = React.ComponentProps<"svg">;

export const HardDriveOffIcon: React.FC<HardDriveOffIconProps> = ({
  strokeWidth = 2,
  ...props
}) => {
  const maskId = `hard-drive-off-${useId().replaceAll(":", "")}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <mask
        id={maskId}
        x="0"
        y="0"
        width="24"
        height="24"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
      >
        <rect width="24" height="24" fill="white" stroke="none" />
        <path d="m2 2 20 20" fill="none" stroke="black" strokeWidth="4" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path d="M10 16h.01" />
        <path d="M2.212 11.577A2 2 0 0 0 2 12.473V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5.527a2 2 0 0 0-.212-.896L18.55 5.11A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
        <path d="M21.946 12.013H2.054" />
        <path d="M6 16h.01" />
      </g>
      <path d="m2 2 20 20" />
    </svg>
  );
};
